// Importing symbol-observable fixes a redux warning.
// More details: https://github.com/reduxjs/redux-toolkit/issues/2008
import { createRoot } from "react-dom/client";

import technicalProblemsImage from "@shared/images/robot-technical.webp";

import App from "./App";
import { unregister } from "./registerServiceWorker";

import "@fortawesome/fontawesome-free/css/all.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/global.css";

import "symbol-observable";
import "./i18n/config";

// The technical-difficulties illustration is pre-cached so the error screen can render instantly,
// but it should never be loaded during startup: it would compete for bandwidth with the code needed for the first paint.
const preloadTechnicalProblemsImage = () => {
    new Image().src = technicalProblemsImage;
};

// requestIdleCallback only reached Safari in version 17, which is still inside our browserslist range.
if ("requestIdleCallback" in window) {
    requestIdleCallback(preloadTechnicalProblemsImage, { timeout: 10000 });
} else {
    setTimeout(preloadTechnicalProblemsImage, 3000);
}

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element #root not found. Make sure index.html includes <div id='root'></div>.");
}

const root = createRoot(rootElement);
root.render(<App />);

unregister();
